import { render, staticRenderFns } from "./DoubleChartSessionScore.vue?vue&type=template&id=b50ebb16&scoped=true&"
import script from "./DoubleChartSessionScore.vue?vue&type=script&lang=js&"
export * from "./DoubleChartSessionScore.vue?vue&type=script&lang=js&"
import style0 from "./DoubleChartSessionScore.vue?vue&type=style&index=0&id=b50ebb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50ebb16",
  null
  
)

export default component.exports